<template>
    <div class="flex min-h-screen w-full bg-white">
        <div class="flex flex-1 justify-center">
            <div
                class="relative flex w-full max-w-(--breakpoint-2xl) flex-col items-center justify-start pt-[115px] pb-6"
            >
                <div
                    class="left-[20px] top-[20px] mt-[24px] sm:absolute sm:mt-0"
                >
                    <a :href="globalProps.homepage_url" target="_blank">
                        <AtomicButton size="md" color="colorless">
                            <ArrowLeft class="h-4 w-4" />
                            {{ $t("vue.back_to_homepage") }}
                        </AtomicButton>
                    </a>
                </div>

                <div>
                    <a :href="globalProps.homepage_url" target="_blank">
                        <PrimaryLogo height="34" width="193" />
                    </a>
                </div>

                <div class="mt-[24px]">
                    <slot />
                </div>
            </div>
        </div>

        <!--TODO: later will be changed and released-->
        <!--        <AuthMarketingMessage-->
        <!--            v-if="-->
        <!--                route().current() === 'register' ||-->
        <!--                route().current() === 'login' ||-->
        <!--                route().current() === 'app.auth.logout-success' ||-->
        <!--                route().current() === 'password.request' ||-->
        <!--                route().current() === 'verification.notice'-->
        <!--            "-->
        <!--        />-->
    </div>
</template>

<script setup lang="ts">
import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";
import { ArrowLeft } from "lucide-vue-next";
import route from "ziggy-js";

const globalProps = computed(() => usePage<IRhizomPageProps>().props);
</script>
